import { PropTypes } from 'react';

const TableHead = ({ children }) => (
    <thead>{children}</thead>
);

TableHead.propTypes = {
    children: PropTypes.node
};

export default TableHead;



// WEBPACK FOOTER //
// ./app/components/table/head.jsx